// extracted by mini-css-extract-plugin
export var aircallIframe = "_cy-3";
export var fabContainer = "_cy-5";
export var fabRinging = "_cy-6";
export var loadingOverlay = "_cy-4";
export var pulse = "_cy-7";
export var widgetContent = "_cy-2";
export var widgetPanel = "_cy-0";
export var widgetPanelExpanded = "_cy-1";